import { createFileRoute } from "@tanstack/react-router";
import { AbroadGuestResult } from "@/components/abroad/AbroadGuestResult";
import { guestResultHead } from "@/components/abroad/abroad-guest-head";
import { getEduCountriesCount, type CountriesHead } from "@/lib/edu-countries-count.functions";

// Результат подбора без кабинета (az). Без индексации: личный документ по
// секретной ссылке. «_» — не вкладывать в лендинг (у него нет <Outlet/>).
export const Route = createFileRoute("/az/xaricde-tehsil_/r/$token")({
  loader: async (): Promise<CountriesHead | null> => {
    try {
      return await getEduCountriesCount();
    } catch {
      return null;
    }
  },
  head: ({ loaderData }) => guestResultHead("az", loaderData),
  component: function GuestResultRoute() {
    const { token } = Route.useParams();
    return <AbroadGuestResult lang="az" token={token} />;
  },
});
